<template>
  <transition name="fade">
    <div class="modal" v-if="isVisible">
      <div class="modal-overlay" v-if="isVisible" />
      <button type="button" class="modal-close" @click="close">
        <Icon class="modal-close-image" glyph="close" />
      </button>
      <div class="modal-content">
        <div v-if="header" class="modal-header">{{ header }}</div>
        <div class="modal-body"><slot /></div>
        <div v-if="footer" class="modal-footer">footer</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {
    Icon: () => import('./Icon')
  },
  data() {
    return {
      isVisible: false
    };
  },
  mounted() {
    this.$root.$on('open_modal', this.open);
  },
  props: {
    footer: {
      type: String,
      default: null
    },
    header: {
      type: String,
      default: null
    }
  },
  methods: {
    open() {
      this.$emit('open');
      this.isVisible = true;
    },
    close() {
      this.$emit('close');
      this.isVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 1000;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.modal-overlay {
  background-color: rgba(#000000, 0.6);
  position: absolute;
  height: 100%;
  width: 100%;
}

.modal-content {
  padding: 10px;
  position: relative;
  z-index: 1010;
}

.modal-body {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
}

.modal-close {
  background: none;
  border: none;
  cursor: pointer;
  height: 48px;
  position: absolute;
  right: 0;
  top: 0;
  margin: 5px;
  width: 48px;
  z-index: 1020;
  transition: background-color 100ms ease-in-out;
  .no-touch &:hover {
    background-color: rgba(#ffffff, 0.2);
  }
}
.modal-close-image {
  fill: #ffffff;
  height: 100%;
  width: 100%;
}

.fade-enter-active {
  animation: fade 300ms;
}
.fade-leave-active {
  animation: fade 300ms reverse;
}
@keyframes fade {
  from {
    opacity: 0;
    visibility: hidden;
  }
  to {
    opacity: 1;
    visibility: visible;
  }
}
</style>
